// Роли и что им можно — без React, чтобы чистые планировщики и тесты могли это импортировать.
// База проверяет то же самое: is_member/is_writer/is_admin и списки в apply_changes (0022).
export const ROLES = ['none', 'viewer', 'member', 'admin'] as const;
export type Role = typeof ROLES[number];

const WRITERS = new Set<string>(['member', 'admin']);
export const isWriter = (role: string | null | undefined): boolean => WRITERS.has(role ?? '');
export const isAdminRole = (role: string | null | undefined): boolean => role === 'admin';

/** Подписи ролей — меню аккаунта, админка, история. */
export const ROLE_LABEL: Record<Role, string> = { none: 'No access', viewer: 'Viewer', member: 'Member', admin: 'Admin' };
export const ROLE_HINT: Record<Role, string> = {
  none: 'Cannot sign in',
  viewer: 'Reads everything, asks questions',
  member: 'Edits the plan',
  admin: 'Plus people, teams and access',
};

/** Справочники и доступ — только админу; всё остальное из плана пишет участник. */
export const ADMIN_TABLES = new Set<string>(['profile', 'person', 'team', 'team_member', 'shared_setting']);
/** Вопросы и ответы — единственное, что пишет наблюдатель. */
export const VIEWER_TABLES = new Set<string>(['question', 'answer']);

export function canWriteTable(role: string | null | undefined, table: string): boolean {
  if (isAdminRole(role)) return true;
  if (ADMIN_TABLES.has(table)) return false;
  if (isWriter(role)) return true;
  return role === 'viewer' && VIEWER_TABLES.has(table);
}
